{
	"passwordUpdated": "Password successfully updated"
}
